var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vc-calendar',{attrs:{"from-page":_vm.page,"masks":{weekdays: 'WWW'},"attributes":_vm.attributes,"is-expanded":true,"min-date":_vm.minDate,"max-date":_vm.maxDate},on:{"update:fromPage":function($event){_vm.page=$event},"update:from-page":function($event){_vm.page=$event},"dayclick":function($event){return _vm.$emit('dayclick', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }